function normalizeText(value) {
  const raw = String(value || "");
  const normalized = typeof raw.normalize === "function" ? raw.normalize("NFD") : raw;
  return normalized
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function applyFilter(container, term) {
  const items = container.querySelectorAll("[data-feature-item]");
  const groups = container.querySelectorAll("[data-feature-group]");
  const nodes = Array.from(container.querySelectorAll("[data-feature-node]"));
  const normalizedTerm = normalizeText(term);
  const nodeById = new Map(nodes.map((node) => [String(node.dataset.featureId), node]));

  items.forEach((item) => {
    const text = normalizeText(item.dataset.featureSearchText);
    const visible = normalizedTerm === "" || text.includes(normalizedTerm);
    item.classList.toggle("d-none", !visible);
  });

  if (normalizedTerm !== "" && nodes.length > 0) {
    nodes.forEach((node) => {
      if (node.classList.contains("d-none")) {
        return;
      }

      let parentId = node.dataset.featureParentId;
      while (parentId) {
        const parentNode = nodeById.get(String(parentId));
        if (!parentNode) {
          break;
        }

        parentNode.classList.remove("d-none");
        parentId = parentNode.dataset.featureParentId;
      }
    });
  }

  let visibleGroups = 0;
  if (groups.length > 0) {
    groups.forEach((group) => {
      const hasVisibleItem = group.querySelector("[data-feature-item]:not(.d-none)");
      group.classList.toggle("d-none", !hasVisibleItem);

      if (group.tagName === "DETAILS" && normalizedTerm !== "" && hasVisibleItem) {
        group.open = true;
      }

      visibleGroups += hasVisibleItem ? 1 : 0;
    });
  } else {
    visibleGroups = container.querySelectorAll("[data-feature-item]:not(.d-none)").length > 0 ? 1 : 0;
  }

  const emptyState = container.querySelector("[data-feature-search-empty]");
  if (emptyState) {
    const hasFilterText = normalizedTerm.length > 0;
    const shouldShowEmpty = items.length > 0 && visibleGroups === 0 && hasFilterText;
    emptyState.classList.toggle("d-none", !shouldShowEmpty);
  }
}

export function initProfileFeatureSearch() {
  document.querySelectorAll("[data-feature-search]").forEach((container) => {
    if (container.dataset.featureSearchInitialized === "1") {
      return;
    }

    const input = container.querySelector("[data-feature-search-input]");
    if (!input) {
      return;
    }

    container.dataset.featureSearchInitialized = "1";

    const runFilter = () => applyFilter(container, input.value);
    input.addEventListener("input", runFilter);
    input.addEventListener("search", runFilter);

    const featureNodes = Array.from(container.querySelectorAll("[data-feature-node]"));
    const nodeById = new Map(
      featureNodes
        .map((node) => [String(node.dataset.featureId || ""), node])
        .filter(([id]) => id !== "")
    );

    const checkboxById = new Map();
    featureNodes.forEach((node) => {
      const featureId = String(node.dataset.featureId || "");
      if (featureId === "") return;

      const checkbox = node.querySelector(
        "[data-feature-checkbox], input[type='checkbox'][name='profile[feature_ids][]']"
      );
      if (checkbox) checkboxById.set(featureId, checkbox);
    });

    const descendantIdsOf = (featureId) => {
      const descendants = [];
      const stack = [String(featureId)];

      while (stack.length > 0) {
        const currentId = stack.pop();
        featureNodes.forEach((node) => {
          if (String(node.dataset.featureParentId || "") !== currentId) return;

          const childId = String(node.dataset.featureId || "");
          if (childId === "") return;

          descendants.push(childId);
          stack.push(childId);
        });
      }

      return descendants;
    };

    const setDescendantsChecked = (featureId, checked) => {
      descendantIdsOf(featureId).forEach((descendantId) => {
        const childCheckbox = checkboxById.get(descendantId);
        if (childCheckbox) childCheckbox.checked = checked;
      });
    };

    const setAncestorsChecked = (featureId, checked) => {
      let currentNode = nodeById.get(String(featureId));

      while (currentNode?.dataset?.featureParentId) {
        const parentId = String(currentNode.dataset.featureParentId);
        const parentCheckbox = checkboxById.get(parentId);
        if (parentCheckbox) parentCheckbox.checked = checked;
        currentNode = nodeById.get(parentId);
      }
    };

    checkboxById.forEach((checkbox, featureId) => {
      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          setDescendantsChecked(featureId, true);
          setAncestorsChecked(featureId, true);
          return;
        }

        setDescendantsChecked(featureId, false);
      });
    });

    const selectAllButton = container.querySelector("[data-feature-select-all]");
    if (selectAllButton) {
      selectAllButton.addEventListener("click", () => {
        const checkboxes = container.querySelectorAll(
          "[data-feature-checkbox], input[type='checkbox'][name='profile[feature_ids][]']"
        );
        checkboxes.forEach((checkbox) => {
          checkbox.checked = true;
        });

        if (input.value !== "") {
          input.value = "";
        }

        runFilter();
      });
    }

    const unselectAllButton = container.querySelector("[data-feature-unselect-all]");
    if (unselectAllButton) {
      unselectAllButton.addEventListener("click", () => {
        const checkboxes = container.querySelectorAll(
          "[data-feature-checkbox], input[type='checkbox'][name='profile[feature_ids][]']"
        );
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        if (input.value !== "") {
          input.value = "";
        }

        runFilter();
      });
    }

    runFilter();
  });
}
